import { useContext } from 'react';

import './EAppShell.scss';

import { AppContext } from '../../../../AppContext';

type Props = {
  navbar: JSX.Element;
  topbar?: JSX.Element;
  children?: JSX.Element;
  footer?: JSX.Element;
};

export function EAppShell({ navbar, topbar, children, footer }: Props) {

  const {
    isSidebarCollapsed
  } = useContext(AppContext);

  return (
    <div className="app-shell ">
      {/* LEFT NAV */}
      <div className={`navbar ${isSidebarCollapsed ? "collapsed" : ""}`}>{navbar}</div>
      {/* MAIN RIGHT PANEL */}
      <div className={'main ' + (footer ? ' has-footer' : '')}>
        {/* TOPBAR */}
        {topbar ? <div className="topbar border--bottom">{topbar}</div> : <></>}
        {/* APP BODY */}
        <div className="body">{children}</div>
        {footer ? <div className="footer border-top">{footer}</div> : <></>}
      </div>
    </div>
  );
}

// export default EAppShell;
